import Vue from 'vue'
const modulesFiles = require.context('./global', true, /index\.js$/)

modulesFiles.keys().forEach(item => {
  // const moduleName = item.replace(/^\.\/(.*)\.\w+$/, '$1').split('/')[0]
  Vue.use(modulesFiles(item).default)
})
